import {CustomerTutorialState} from "../store/customer_tutorial_state";
import {Reducer} from "redux";
import {
    CustomerTutorialAction,
    CustomerTutorialActionType, ICallbackGetAllByRecommendProjectListAction
} from "../action/customer_tutorial_action";

const initialState: CustomerTutorialState = {
    projectList: [],
};

const customerTutorialReducer: Reducer<CustomerTutorialState> = (state = initialState, action: CustomerTutorialAction): CustomerTutorialState => {
    switch (action.type) {
        case CustomerTutorialActionType.CALLBACK_GET_ALL_BY_RECOMMEND_PROJECT_LIST: {
            const _action = action as ICallbackGetAllByRecommendProjectListAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    projectList: _action.item,
                });
            } else {
                return state;
            }
        }
        default:
            return state;
    }
};

export default customerTutorialReducer;


// WEBPACK FOOTER //
// ./src/presentation/reducer/customer_tutorial_reducer.ts